/**
 * @deprecated in favor of useMobileObserver
 */
export default () => {
  const currentDevice = window
    .getComputedStyle(document.querySelector('body'), '::before')
    .getPropertyValue('content')
    .replace(/\"/g, '');

  return currentDevice === 'mobile';
};
